"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTableControlsCell = exports.EntityTableControlsCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_button_1 = require("../elements/icon-button");
var use_lang_1 = require("../../hooks/use-lang");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var sprintf_js_1 = require("sprintf-js");
exports.EntityTableControlsCellDefaultProps = {
  countStyle: "normal",
  count: 0
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: ", " ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CreateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    text-transform: uppercase;\n  "], ["\n    font-size: ", ";\n    text-transform: uppercase;\n  "])), theme_1.theme.FONT_SIZE(13))
});
var CountLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 0.85em;\n    background: #FFF;\n    padding: 4px 8px;\n    border-radius: 20px;\n    color: #777;\n  "], ["\n    font-size: 0.85em;\n    background: #FFF;\n    padding: 4px 8px;\n    border-radius: 20px;\n    color: #777;\n  "])))
});
var CreateButtonContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  CreateButton: (0, styled_components_1.default)(icon_button_1.CreateIconButton).attrs({
    iconSize: 20
  })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), CreateButtonStyles),
  CountLabel: styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), CountLabelStyles),
  CreateButtonContainer: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CreateButtonContainerStyles)
};
var EntityTableControlsCell = function (props) {
  var className = props.className,
    count = props.count,
    countStyle = props.countStyle,
    onAdd = props.onAdd,
    entityTypeName = props.entityTypeName,
    loading = props.loading;
  var t = (0, use_lang_1.useLang)();
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var addLabelTemplate = props.addLabelTemplate || (countStyle === "normal" ? definition.create.label : 'Add %s');
  var addLabel = (0, sprintf_js_1.sprintf)(t(addLabelTemplate), definition.label);
  // console.log(countStyle);
  var countLabel = countStyle === "normal" ? count === 1 ? definition.oneLabel : count === 0 ? definition.zeroLabel : (0, sprintf_js_1.sprintf)(definition.nLabel, count) : count === 0 ? (0, sprintf_js_1.sprintf)(t('No %s Defined'), definition.label) : '';
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.CreateButtonContainer, {
    onClick: onAdd
  }, onAdd && react_1.default.createElement(My.CreateButton, null, addLabel)), countLabel ? react_1.default.createElement(My.CountLabel, null, loading ? t('Please wait') : countLabel) : react_1.default.createElement("span", null));
};
exports.EntityTableControlsCell = EntityTableControlsCell;
exports.EntityTableControlsCell.defaultProps = exports.EntityTableControlsCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;